import type { Vehicle } from '@data/fms/vehicle/types';

export const getDriveLink = (vehicle: Vehicle) =>
  `https://${import.meta.env.VITE_DRIVE_CONSOLE_DOMAIN}/vehicles/${
    vehicle.vehicle_id
  }?project_id=${vehicle.project_id}&environment_id=${
    vehicle.environment_id
  }&mode=standby`;
